var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
/* eslint-disable max-len */
/**
 * A component which applies the necessary `className` for correct styling of child elements inside the [SchedulerItem]({% slug api_scheduler_scheduleritem %})
 */
export var SchedulerItemContent = React.forwardRef(function (props, ref) {
    var className = React.useMemo(function () { return classNames('k-event-template', props.className); }, [props.className]);
    return (React.createElement("div", __assign({ ref: ref }, props, { className: className })));
});
